<template>
    <b-card>
        <div class="table-responsive">
            <b-table bordered striped hover show-empty
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
            >
            </b-table>
        </div>
    </b-card>
</template>

<script>
    import FormatsDates from "../../../mixins/FormatsDates";

    export default {
        name: "DailyImportsReport",

        mixins: [FormatsDates],

        props: {
            imports: Array,
        },

        data() {
            return {
                items: this.imports,
                sortBy: null,
                sortDesc: false,
                filter: null,
                fields: [
                    {
                        key: 'created_at',
                        label: 'Date',
                        sortable: true,
                        formatter: val => this.formatDateFromUTC(val)
                    },
                    {
                        key: 'filename',
                        sortable: true,
                    },
                    {
                        key: 'error_count',
                        sortable: true,
                    },
                    {
                        key: 'added_clients',
                        label: 'Claimants Added',
                        sortable: true,
                    },
                    {
                        key: 'updated_clients',
                        label: 'Claimants Updated',
                        sortable: true,
                    },
                    {
                        key: 'deleted_clients',
                        label: 'Claimants Deactivated',
                        sortable: true,
                    },
                    {
                        key: 'added_caregivers',
                        label: 'Providers Added',
                        sortable: true,
                    },
                    {
                        key: 'updated_caregivers',
                        label: 'Providers Updated',
                        sortable: true,
                    },
                    {
                        key: 'deleted_caregivers',
                        label: 'Providers Deactivated',
                        sortable: true,
                    },
                ]
            }
        }
    }
</script>

<style scoped>

</style>